import { gql } from "@apollo/client";

export const GET_CONVERSATION_BY_REFERENCE_ID = gql`
  query GetConversationByReferenceId($params: GetConversationByReferenceIdInput!) {
    conversationByReferenceId(params: $params) {
      id
      referenceId
      categoryKey
      categoryTypeKey
      invoiceNumber
      checkNumber
      purchaserKey
      purchaserName
      remittanceItemId
      remittanceId
      participants {
        email
        firstName
        lastName
        fullName
        avatar
        isDeleted
        participantId
      }
      createdAt
      updatedAt
    }
  }
`;
